import Editor from './taskEditor';

export default Editor;
